/**
 * EventPady+ — Application Entry Point
 *
 * Initialisation order:
 *   1. Sentry — must be first so it can capture any startup errors
 *   2. React root — renders the application tree
 */
import { createRoot } from 'react-dom/client'
import './styles/globals.css'
import { App } from './app/App'
import { initSentry } from './lib/sentry'

// ── 1. Error tracking ───────────────────────────────────────────────────────
// initSentry() is a no-op when VITE_SENTRY_DSN is unset (local dev / tests).
initSentry()

// ── 2. React root ───────────────────────────────────────────────────────────
const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error(
    'Root element #root not found. Check index.html contains <div id="root"></div>.',
  )
}

// StrictMode temporarily disabled during screenshot capture session — re-enable after.
createRoot(rootElement).render(<App />)
